module.exports = __webpack_public_path__ + "static/media/crystalstructureThumb.52cd6c77.png";


//////////////////
// WEBPACK FOOTER
// ./src/photos/crystalstructureThumb.png
// module id = 387
// module chunks = 0